module.exports = __webpack_public_path__ + "static/media/corpu_doc8.3c450460.jpg";